var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronsDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Size=16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.38388 4.38388C4.54009 4.22767 4.79336 4.22767 4.94957 4.38388L8.00006 7.43437L11.0505 4.38388C11.2068 4.22767 11.46 4.22767 11.6162 4.38388C11.7724 4.54009 11.7724 4.79336 11.6162 4.94957L8.2829 8.2829C8.12669 8.43911 7.87342 8.43911 7.71721 8.2829L4.38388 4.94957C4.22767 4.79336 4.22767 4.54009 4.38388 4.38388ZM4.38388 8.38388C4.54009 8.22767 4.79336 8.22767 4.94957 8.38388L8.00006 11.4344L11.0505 8.38388C11.2068 8.22767 11.46 8.22767 11.6162 8.38388C11.7724 8.54009 11.7724 8.79336 11.6162 8.94957L8.2829 12.2829C8.12669 12.4391 7.87342 12.4391 7.71721 12.2829L4.38388 8.94957C4.22767 8.79336 4.22767 8.54009 4.38388 8.38388Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronsDown);
export default __webpack_public_path__ + "static/media/chevrons-down.309a22a797ad8bbe6de69fbc04dde990.svg";
export { ForwardRef as ReactComponent };